import { createReducer } from "@reduxjs/toolkit";
import {
  APP_RULES_LOADING,
  GET_APP_RULES,
  APP_RULES_ERROR,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const appRulesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(APP_RULES_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(APP_RULES_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(GET_APP_RULES, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default appRulesReducer;
